<template>
  <div class="product-page">
    <section class="product-page-hero subpage-image-hero" aria-label="产品中心">
      <img src="@/assets/image/product_banner.png" alt="产品中心" @load="updateProductTabsFixed">
      <div class="container subpage-hero-inner">
        <div class="subpage-hero-copy">
          <span style="font-size: 2rem; font-weight: 600;">产品中心</span>
          <p>厘米级精度全球覆盖，守护每一刻位置</p>
        </div>
      </div>
    </section>

    <nav class="product-tabs" :class="{ 'is-fixed': isProductTabsFixed }" aria-label="产品分类">
      <div class="container product-tabs-inner">
        <button
          v-for="(category, index) in productCategories"
          :key="category.title"
          type="button"
          :class="{ active: activeCategoryIndex === index }"
          @click="scrollToCategory(index)"
        >
          {{ category.title }}
        </button>
      </div>
    </nav>

    <main class="product-content">
      <section
        v-for="category in productCategories"
        :id="category.id"
        :key="category.title"
        ref="categorySections"
        class="product-category"
      >
        <div class="container">
          <div class="product-category-banner">
            <img :src="category.banner" :alt="category.title">
            <div class="product-category-copy">
              <h2>{{ category.bannerTitle }}</h2>
              <p>{{ category.bannerDesc }}</p>
            </div>
          </div>
          <div class="product-grid-page">
            <article v-for="item in category.products" :key="item.name" class="product-item-page">
              <div class="product-item-visual">
                <img :src="item.image" :alt="item.name">
              </div>
              <h2>{{ item.name }}</h2>
              <p>{{ item.desc }}</p>
              <router-link to="/contact">了解更多 →</router-link>
            </article>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'CasesView',
  data() {
    return {
      activeCategoryIndex: 0,
      isProductTabsFixed: false,
      productCategories: [
        {
          id: 'global-4g',
          title: '4G全球通系列',
          banner: require('@/assets/image/product1_banner.png'),
          kicker: '4G GLOBAL SERIES',
          bannerTitle: '4G全球通系列',
          bannerDesc: '4G GLOBAL COMMUNICATION',
          products: [
            { name: '千讯Q7', desc: '精致小巧，易于隐藏携带。全球定位，定位准确无误', image: require('@/assets/image/product1_1.png') },
            { name: '千讯Q10', desc: '4G强速定位，瞬间锁定位置，精准高效，超长续航', image: require('@/assets/image/product1_2.png') },
            { name: '千讯Q19', desc: '4G疾速定位，精准追踪无忧', image: require('@/assets/image/product1_3.png') },
            { name: '千讯Q16', desc: '智能报警提醒，安全守护每一刻', image: require('@/assets/image/product1_4.png') },
            { name: '千讯Q17', desc: '超长待机时间，持久追踪不间断', image: require('@/assets/image/product1_5.png') },
            { name: '千讯Q12', desc: '历史轨迹回放，行程记录一目了然', image: require('@/assets/image/product1_6.png') }
          ]
        },
        {
          id: 'cross-border',
          title: '外贸跨境系列',
          banner: require('@/assets/image/product2_banner.png'),
          kicker: 'CROSS-BORDER SERIES',
          bannerTitle: '外贸跨境系列',
          bannerDesc: 'CROSS BORDER FOREIGN TRADE',
          products: [
            { name: '千讯GF08', desc: '精致小巧，易于隐藏携带。全球定位，定位准确无误', image: require('@/assets/image/product2_1.png') },
            { name: '千讯GF09', desc: '4G强速定位，瞬间锁定位置，精准高效，超长续航', image: require('@/assets/image/product2_2.png') },
            { name: '千讯GF10', desc: '4G疾速定位，精准追踪无忧', image: require('@/assets/image/product2_3.png') },
            { name: '千讯GF11', desc: '智能报警提醒，安全守护每一刻', image: require('@/assets/image/product2_4.png') },
            { name: '千讯PG13', desc: '超长待机时间，持久追踪不间断', image: require('@/assets/image/product2_5.png') },
            { name: '千讯PG12', desc: '历史轨迹回放，行程记录一目了然', image: require('@/assets/image/product2_6.png') }
          ]
        },
        {
          id: 'security',
          title: '智能安全守护',
          banner: require('@/assets/image/product3_banner.png'),
          kicker: 'SMART SAFETY PROTECTION',
          bannerTitle: '智能安全守护',
          bannerDesc: 'INTELLIGENT SECURITY PROTECTION',
          products: [
            { name: '千讯M7', desc: '精致小巧，易于隐藏携带。全球定位，定位准确无误', image: require('@/assets/image/product3_1.png') },
            { name: '千讯M9', desc: '4G强速定位，瞬间锁定位置，精准高效，超长续航', image: require('@/assets/image/product3_2.png') },
            { name: '千讯M4', desc: '4G疾速定位，精准追踪无忧', image: require('@/assets/image/product3_3.png') },
            { name: '千讯M1', desc: '智能报警提醒，安全守护每一刻', image: require('@/assets/image/product3_4.png') },
            { name: '千讯M2', desc: '超长待机时间，持久追踪不间断', image: require('@/assets/image/product3_5.png') },
            { name: '千讯Q19', desc: '历史轨迹回放，行程记录一目了然', image: require('@/assets/image/product3_6.png') }
          ]
        },
        {
          id: 'customized',
          title: '定制化定位器',
          banner: require('@/assets/image/product4_banner.png'),
          kicker: 'CUSTOMIZED TRACKERS',
          bannerTitle: '定制化定位器',
          bannerDesc: 'CUSTOMIZED LOCATOR',
          products: [
            { name: '千讯M8', desc: '炫彩灯光 安心陪伴', image: require('@/assets/image/product4_1.png') },
            { name: '千讯M10', desc: '精致小巧 悄悄守护', image: require('@/assets/image/product4_2.png') },
            { name: '千讯PG07', desc: '免充电持续定位', image: require('@/assets/image/product4_3.png') },
            { name: '千讯M1', desc: '智能报警提醒，安全守护每一刻', image: require('@/assets/image/product4_4.png') },
            { name: '千讯M2', desc: '超长待机时间，持久追踪不间断', image: require('@/assets/image/product4_5.png') },
            { name: '千讯Q19', desc: '历史轨迹回放，行程记录一目了然', image: require('@/assets/image/product4_6.png') }
          ]
        }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleProductScroll, { passive: true })
    window.addEventListener('resize', this.updateProductTabsFixed)
    this.handleProductScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleProductScroll)
    window.removeEventListener('resize', this.updateProductTabsFixed)
  },
  methods: {
    scrollToCategory(index) {
      const section = this.$refs.categorySections[index]
      if (!section) return
      const headerOffset = window.matchMedia('(max-width: 860px)').matches ? 64 : 120
      const top = section.getBoundingClientRect().top + window.pageYOffset - headerOffset
      window.scrollTo({ top, behavior: 'smooth' })
      this.activeCategoryIndex = index
    },
    handleProductScroll() {
      this.updateProductTabsFixed()
      const sections = this.$refs.categorySections || []
      const offset = window.matchMedia('(max-width: 860px)').matches ? 120 : 150
      let activeIndex = 0
      sections.forEach((section, index) => {
        if (section.getBoundingClientRect().top <= offset) {
          activeIndex = index
        }
      })
      this.activeCategoryIndex = activeIndex
    },
    updateProductTabsFixed() {
      const hero = this.$el.querySelector('.product-page-hero')
      if (!hero) return
      const headerHeight = window.matchMedia('(max-width: 860px)').matches ? 64 : 60
      const heroBottom = hero.getBoundingClientRect().bottom + window.pageYOffset
      this.isProductTabsFixed = window.pageYOffset >= heroBottom - headerHeight
    }
  }
}
</script>
